<template>
  <IconWrapper name="cancel" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 11.75C2 6.374 6.374 2 11.75 2C17.126 2 21.5 6.374 21.5 11.75C21.5 17.126 17.126 21.5 11.75 21.5C6.374 21.5 2 17.126 2 11.75ZM15.9996 9.14228C16.3151 8.82673 16.3151 8.31512 15.9996 7.99955C15.684 7.68399 15.1724 7.684 14.8568 7.99955L12 10.8564L9.14318 7.99955C8.82762 7.684 8.31601 7.68399 8.00045 7.99955C7.68488 8.31512 7.68489 8.82673 8.00045 9.14228L10.8573 11.9991L8.00045 14.8559C7.68488 15.1715 7.68488 15.6831 8.00045 15.9987C8.31601 16.3142 8.82761 16.3142 9.14318 15.9987L12 13.1418L14.8568 15.9987C15.1724 16.3142 15.684 16.3142 15.9996 15.9987C16.3151 15.6831 16.3151 15.1715 15.9996 14.8559L13.1427 11.9991L15.9996 9.14228Z"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
}>()
</script>
